var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative",class:{ 'set-active': _vm.selected }},[_c('NuxtLink',{staticClass:"sticky-navigation-menu-item flex flex-col absolute left-0 right-0 mx-auto top-0",class:{
      'sticky-navigation-menu-item-active pb-2': _vm.selected
    },attrs:{"to":_vm.to}},[_c('span',{staticClass:"block pb-rem"},[_c('OSvg',{staticClass:"w-5 mx-auto",class:{
          'fill-newBlue-400': _vm.selected,
          'fill-neutral-800': !_vm.selected
        },attrs:{"svg":(_vm.svgPrefix + "-" + (_vm.selected ? 'solid' : 'outline'))}})],1),_vm._v(" "),_c('span',{staticClass:"o-footer text-center",class:{
        'font-bold text-newBlue-400': _vm.selected,
        'text-neutral-800': !_vm.selected
      },domProps:{"textContent":_vm._s(_vm.text)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }